import { IconButton, Menu, MenuItem, Slider, Box, Typography } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import PlatformSharingComponent from "../../../views/Magazine/NewsDeployment/MusicChannels/PlatformSharingComponent";

import { useContext, useState } from "react";
import { PlayerContext } from "../../../context/PlayerContext";

const MobileMenu = ({ isMuted, setIsMuted, volumeLevel, setVolumeLevel, setOpen }) => {
    const { previousSongIndex, nextSongIndex, playlist } = useContext(PlayerContext);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMuteToggle = () => {
        if (isMuted) {
            setOpen(true);
        }
        setIsMuted(!isMuted);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };
   
    return (
        <Box
            sx={{
                position: "absolute",
                top: { xs: "1rem", md: "0.5rem" },
                right: { xs: "1rem", md: "2rem" },
                fontSize:"small",
                width: "1rem",
                zIndex: 3,
            }}
        >
            <IconButton
                onClick={handleMenuOpen}
                sx={{ color: "white", "&:hover": { color: "#f0f0f0" },transform: 'rotate(90deg)' }}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleMenuClose}
                sx={{
                    "& .MuiPaper-root": { backgroundColor: "black", minWidth: "150px", padding: "8px" },
                }}
            >
                <Box>
                    <Typography
                        component="h1"
                        variant="h3"
                        sx={{
                            fontWeight: "normal",
                            color: "white",
                            fontSize: { xs: "0.8rem", md: "0.8rem"  },
                            textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
                        }}
                    >
                        Cancion anterior: {playlist[previousSongIndex]?.songName}
                    </Typography>
                    <Typography
                        component="h1"
                        variant="h3"
                        sx={{
                            fontWeight: "normal",
                            color: "white",
                            fontSize: { xs: "0.8rem", md: "0.8rem" },
                            textShadow: "1px 1px 3px rgba(0,0,0,0.5)",
                        }}
                    >
                        Cancion siguiente: {playlist[nextSongIndex]?.songName}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: { xs: "flex", md: "none" },
                        flexDirection: "column",
                        alignItems: "center",
                    }}
                >
                    <MenuItem
                        sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
                    >
                        <IconButton color="primary" onClick={handleMuteToggle}>
                            {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
                        </IconButton>
                        <Slider
                            size="small"
                            value={volumeLevel}
                            max={100}
                            onChange={(e) => setVolumeLevel(e.target.value)}
                            sx={{ width: "80px" }}
                        />
                    </MenuItem>
                    <MenuItem sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <PlatformSharingComponent
                            shareText="Alta-Voz-Radio:"
                            currentUrl={`${process.env.REACT_APP_URL_FRONT}altavoztv`}
                        />
                    </MenuItem>
                </Box>
            </Menu>
        </Box>
    );
};

export default MobileMenu;
